import React, { useState, useEffect, useRef } from "react";

import { Box } from "@metrea-ui/v2";
import styles from "./ChooseTwoValues.module.css";

import VerticalRangeSlider from "../VerticalSlider/VerticalRangeSlider";

import { findObjectByProperty, getRandomInteger } from "src/utils/dataUtils";
import { applyFormatToNumber } from "src/utils/formatUtils";
import { debugLog } from "src/utils/debugUtils";

const ChooseTwoValues = (props) => {
	const renderCount = useRef(0);
	renderCount.current++;

	const [thisCfg, setThisCfg] = useState({});

	const getArrayItems = (cfg) => {
		const cfgTypes = ["Near-term", "Long-term"];
		let arrayTemp = [];
		for (let idx = 1; idx <= 2; idx++) {
			if (cfg[`comp_value${idx}`]) {
				arrayTemp.push({
					id: idx,
					comp_id: cfg.comp_id,
					type: cfgTypes[idx - 1],
					value: cfg[`comp_value${idx}`],
				});
			}
		}
		arrayTemp.sort((x, y) => x.value - y.value);
		return arrayTemp;
	};
	const [arrayItems, setArrayItems] = useState([]);

	useEffect(() => {
		let thisCfg = findObjectByProperty(props.scenarioConfigs, "comp_id", props.extra.id);

		if (!thisCfg) {
			thisCfg = {
				id: getRandomInteger(),
				scenario_id: props.extra.scenario_id,
				comp_type_id: props.pref.id === 601 ? props.extra.type_id : props.extra.comp_type_id,
				comp_id: props.extra.id,
				comp_value1: "0",
				comp_value2: "0",
				comp_value3: null,
				comp_value4: null,
				comp_value5: null,
				comp_value6: null,
				status_id: 1,
				sort_id: 1000,
				photo: null,
				thumbnail: null,
				color: null,
				createdAt: "2023-10-02T12:18:26.433Z",
				updatedAt: "2023-10-02T12:18:26.433Z",
				createdBy: 0,
				updatedBy: 0,
			};
			props.scenarioConfigs.push(thisCfg);
		}

		setThisCfg({ ...thisCfg });
		setArrayItems([...getArrayItems({ ...thisCfg })]);
	}, [props.scenarioConfigs, props.extra, props.pref]);

	const sliderChangeHandler = (items) => {
		items.map((x) => {
			thisCfg[`comp_value${x.id}`] = x.value;
			thisCfg.update_flag = 102;
			return false;
		});
		setThisCfg({ ...thisCfg });

		props.onChange(thisCfg);

		debugLog(3, "[ChooseTwoValues][ACTION] sliderChangeHandler", {
			props: props,
			items: items,
			thisCfg: thisCfg,
		});
	};

	if (thisCfg?.id === 530) {
		// debugLog(10, "[ChooseTwoValues] - render", {
		// 	props: props,
		// 	renderCount: renderCount.current,
		// 	thisCfg: thisCfg,
		// 	arrayItems: arrayItems,
		// });
	}

	return (
		<Box minH="280px" w="100%" h="100%" p="0">
			<Box minH="20%" mb="10px">
				{props.extra.total_budget_per_year && (
					<label className={styles.configLabel}>
						Budget:{" "}
						{applyFormatToNumber(
							props.extra.total_budget_per_year,
							props.extra.decimalPoint,
							props.extra.currencySymbol,
							props.extra.currencyUnit,
						)}
					</label>
				)}

				<label className={styles.configLabel}>{props.label}</label>
			</Box>
			<div
				className={styles.configGroup}
				style={props.range !== "normalized" ? { paddingRight: "40%" } : {}}
			>
				<VerticalRangeSlider
					key={`range-${props.extra.id}`}
					items={arrayItems}
					range={props.range}
					step={props.step}
					mode={props.mode}
					extra={props.extra}
					onChange={sliderChangeHandler}
				/>
			</div>
		</Box>
	);
};

export default ChooseTwoValues;
